// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"404e8aab","52":"b9e3b0d3","247":"2939d00f","257":"f4f5fcc9","542":"6238aec9","589":"7ae2e56e","894":"1a21f829","959":"2d5bcf45","961":"f5ff48c3"}[chunkId] + ".chunk.js";
};